/**
 * src/pages/Familias.jsx
 * Familias/tiendas CM: qué clientes hay en cada una (incluye multi-tienda).
 */
import { useNavigate } from 'react-router-dom'
import { Header } from '../components/layout/Header'
import { Card, KpiCard } from '../components/ui/Card'
import { Badge, TIER_COLOR } from '../components/ui/Badge'
import { useFamilias } from '../hooks/useAdminPanel'

function FilaCliente({ cliente, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '9px 0', borderBottom: '1px solid var(--color-border)',
        cursor: 'pointer',
      }}
      onMouseEnter={e => e.currentTarget.style.opacity = '0.75'}
      onMouseLeave={e => e.currentTarget.style.opacity = '1'}
    >
      <div>
        <span style={{ fontSize: '13px', fontWeight: 500, color: 'var(--color-text)' }}>
          {cliente.nombre}
        </span>
        <span style={{
          fontSize: '11px', color: 'var(--color-text-3)',
          fontFamily: 'var(--font-mono)', marginLeft: '8px',
        }}>
          {cliente.cliente_id}{!cliente.es_principal && ' · multi-tienda'}
        </span>
      </div>
      <div style={{ display: 'flex', gap: '6px' }}>
        <Badge color={TIER_COLOR[cliente.tier] || 'gray'}>{cliente.tier}</Badge>
        <Badge color={cliente.activo ? 'green' : 'gray'} dot>
          {cliente.activo ? 'activo' : 'inactivo'}
        </Badge>
      </div>
    </div>
  )
}

export default function Familias() {
  const navigate = useNavigate()
  const { data, isLoading } = useFamilias()
  const familias = data?.familias || []
  const totalClientes = new Set(
    familias.flatMap(f => f.clientes.map(c => c.cliente_id))
  ).size

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Header title="Familias CM" subtitle="Tiendas de Convenio Marco y sus clientes" />

      <div style={{ flex: 1, overflow: 'auto', padding: '24px 28px' }}>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '14px',
          marginBottom: '24px',
        }}>
          <KpiCard label="FAMILIAS CON CLIENTES" value={isLoading ? '—' : familias.length}
                   color="var(--color-running)" />
          <KpiCard label="CLIENTES" value={isLoading ? '—' : totalClientes}
                   sub="algunos presentes en varias tiendas" />
        </div>

        {isLoading ? (
          <div style={{
            textAlign: 'center', padding: '32px', color: 'var(--color-text-3)',
            fontSize: '12px', fontFamily: 'var(--font-mono)',
          }}>
            Cargando…
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '14px' }}>
            {familias.map(f => (
              <Card
                key={f.familia}
                title={f.familia}
                subtitle={`${f.n_activos} activos de ${f.n_clientes}`}
              >
                {f.clientes.map(c => (
                  <FilaCliente
                    key={`${f.familia}_${c.cliente_id}`}
                    cliente={c}
                    onClick={() => navigate(`/clientes/${c.cliente_id}`)}
                  />
                ))}
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
